import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, H4, Text, Small, Checkbox, Tooltip } from '@bigcommerce/big-design';

import { downloadOrderPdf } from '../../redux/actions/purchaseOrders';


const DownloadPdfModal = ({ payload, settings, purchaseOrder, download, downloadUrl, showDownloadPdfModal, setShowDownloadPdfModal }) => {
  const [submitted, setSubmitted] = useState(false);
  const [downloadOptions, setDownloadOptions] = useState({});

  useEffect(() => {
    if(downloadUrl && submitted) { 
      setSubmitted(false);
      setTimeout(() => {
        let win = window.open(downloadUrl, '_blank');
        win.focus();
      }, 0);

      // TODO: set "now download? click here" message instead of closing
      setShowDownloadPdfModal(false);
    }
  }, [downloadUrl]);

  useEffect(() => {
    let taxColumn = settings.settings['tax_column'];

    if((settings.settings['tax_column'] === undefined) || (settings.settings['tax_column'] === null)) {
      taxColumn = true;
    }

    setDownloadOptions({
      poNum: (purchaseOrder?.supplier_order_number.match('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$') === null),
      invoiceNum: (purchaseOrder?.invoice_number.match('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$') === null),
      deliveryDate: true,
      paymentExpectedDate: true,
      adjustedPrice: !!(purchaseOrder?.adjusted_price),
      estimatedShippingPrice: !!(parseFloat(purchaseOrder?.shipping_price)),
      taxColumn: taxColumn,
      imagesPage: false,
    })
  }, [purchaseOrder]);

  const toggleOption = (option) => {
    let newOptions = { ...downloadOptions };
    newOptions[option] = !newOptions[option];

    setDownloadOptions(newOptions);
  }
  
  const downloadPdf = () => {
    setSubmitted(true);
    download(payload, purchaseOrder?.id, downloadOptions);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Close',
          variant: 'subtle',
          disabled: submitted,
          onClick: () => setShowDownloadPdfModal(false),
        },
        { isLoading: submitted, disabled: submitted, text: 'Download PO PDF', onClick: () => downloadPdf() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Download PO PDF"
      isOpen={showDownloadPdfModal}
      onClose={() => setShowDownloadPdfModal(false)}
    >
      <H4><strong>{`${settings.settings['invoice_number_override'] || 'Invoice Number'}`}</strong>: { purchaseOrder?.invoice_number }</H4>
      <H4><strong>{`${settings.settings['purchase_order_number_override'] || 'Purchase Order Number'}`}</strong>: { purchaseOrder?.supplier_order_number }</H4>

      <H3>PDF Options</H3>
      <Small>
        Toggle options to appear in the PDF. Disabled options can be enabled in later downloads.
      </Small>

      <Checkbox
        checked={downloadOptions.invoiceNum}
        label={`${settings.settings['invoice_number_override'] || 'Invoice Number'}`}
        onChange={() => toggleOption('invoiceNum')}
      />

      <Checkbox
        checked={downloadOptions.poNum}
        label={`${settings.settings['purchase_order_number_override'] || 'Purchase Order Number'}`}
        onChange={() => toggleOption('poNum')}
      />

      <Checkbox
        checked={downloadOptions.deliveryDate}
        label="Delivery Date"
        onChange={() => toggleOption('deliveryDate')}
      />

      <Checkbox
        checked={downloadOptions.paymentExpectedDate}
        label="Payment Expected Date"
        onChange={() => toggleOption('paymentExpectedDate')}
      />

      <Checkbox
        checked={downloadOptions.adjustedPrice}
        label="Adjusted Price"
        onChange={() => toggleOption('adjustedPrice')}
      />

      <Checkbox
        checked={downloadOptions.estimatedShippingPrice}
        label="Est. Shipping"
        onChange={() => toggleOption('estimatedShippingPrice')}
      />

      <Checkbox
        checked={downloadOptions.taxColumn}
        label="Tax Column"
        onChange={() => toggleOption('taxColumn')}
      />

      <Checkbox
        checked={downloadOptions.imagesPage}
        label="Product Images Page"
        onChange={() => toggleOption('imagesPage')}
      />
      
    </Modal>
  )
}

const mapStateToProps = state => ({ 
  settings: state.settings,
  downloadUrl: state.purchaseOrders.downloadUrl,
});

const mapDispatchToProps = (dispatch) => ({
  download: (payload, purchaseOrderId, options) => dispatch(downloadOrderPdf(payload, 'outstanding', purchaseOrderId, options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPdfModal);